module.exports = __webpack_public_path__ + "static/img/image-gallery.102527d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image-gallery.jpg
// module id = so+R
// module chunks = 0